export const starRating = {
  isOpen: true,
  data: [...Array(5)].map((item, index) => ({
    label: `${index + 1} Star${index > 0 ? 's' : ''}`,
    checked: index > 2,
    name: `starRating${index + 1}`,
  })),
};

export const tripadvisorRating = {
  isOpen: true,
  data: [...Array(5)].map((item, index) => ({
    label: `${index + 1} Star${index > 0 ? 's' : ''}`,
    checked: index > 2,
    name: `tripAdvisor${index + 1}`,
  })),
};

export const priceRange = {
  isOpen: true,
  slider: {
    value: [99, 599],
    valueColor: '#3ff09f',
    min: 1,
    max: 1000,
    units: '$',
    unitsPosition: 'pre',
    leftLabel: 'PER NIGHT',
  },
};

export const propertyType = {
  isOpen: true,
  data: [
    {
      label: 'Hotel',
      name: 'hotel',
      checked: true,
    },
    {
      label: 'Apartment',
      name: 'apartment',
      checked: false,
    },
    {
      label: 'Bungalow',
      name: 'bungalow',
      checked: false,
    },
  ],
};

export const roomClass = {
  isOpen: true,
  data: [
    {
      label: 'Standard',
      name: 'standard',
      checked: false,
    },
    {
      label: 'Deluxe',
      name: 'deluxe',
      checked: true,
    },
    {
      label: 'Family',
      name: 'family',
      checked: false,
    },
    {
      label: 'Suite',
      name: 'suite',
      checked: false,
    },
  ],
};

export const bedding = {
  isOpen: true,
  data: [
    {
      label: 'Queen',
      name: 'queen',
      checked: false,
    },
    {
      label: 'Two Queen',
      name: 'two-queen',
      checked: false,
    },
    {
      label: 'King',
      name: 'king',
      checked: false,
    },
    {
      label: 'Two King',
      name: 'two-king',
      checked: true,
    },
  ],
};

export const pointOfInterest = {
  isOpen: true,
  slider: {
    value: 10,
    min: 1,
    max: 15,
    valuePosition: 'right',
    unitsPosition: 'post',
    leftLabel: 'Max Distance',
  },
  inputValue: '',
};

export const amenities = {
  isOpen: true,
  inputValue: '',
  selected: [],
};

export const occupancy = {
  isOpen: true,
  selectValue: {
    id: 0,
    label: 0,
  },
  selectOptions: [
    {
      id: 0,
      label: 0,
    },
    {
      id: 1,
      label: 1,
    },
    {
      id: 2,
      label: 2,
    },
    {
      id: 3,
      label: 3,
    },
  ],
};

export const roomSize = {
  isOpen: true,
  slider: {
    value: 350,
    min: 0,
    max: 2000,
    units: 'sqm',
    leftLabel: 'Min',
    rightLabel: 'Max',
    getValueLabel() {
      return `${this.min}-${this.value}${this.units}`;
    },
  },
};

export const mealPlan = {
  isOpen: true,
  data: [
    {
      label: 'European',
      name: 'european',
      checked: false,
    },
    {
      label: 'Continental',
      name: 'continental',
      checked: false,
    },
    {
      label: 'Bed & Brakefast',
      name: 'bed-brakefast',
      checked: false,
    },
    {
      label: 'American',
      name: 'american',
      checked: true,
    },
  ],
};

export const hotelChain = {
  isOpen: true,
  data: [
    {
      label: 'Marriott',
      name: 'marriott',
      checked: false,
    },
    {
      label: 'Hilton',
      name: 'hilton',
      checked: false,
    },
    {
      label: 'Hyatt',
      name: 'hyatt',
      checked: false,
    },
    {
      label: 'IHG',
      name: 'ihg',
      checked: true,
    },
    {
      label: 'Wyndham',
      name: 'Wyndham',
      checked: true,
    },
    {
      label: 'Accor',
      name: 'accor',
      checked: true,
    },
    {
      label: 'Choice',
      name: 'choice',
      checked: false,
    },
    {
      label: 'NH',
      name: 'nh',
      checked: false,
    },
  ],
};

export const deals = {
  isOpen: true,
  data: [
    {
      label: 'Only show properties offering special deals',
      name: 'with-special-deals',
      checked: true,
    },
  ],
};

export const refundability = {
  isOpen: true,
  data: [
    {
      label: 'Only show refundable properties',
      name: 'refundable',
      checked: true,
    },
  ],
};

export const view = {
  isOpen: true,
  data: [
    {
      label: 'Pool',
      name: 'pool',
      checked: false,
    },
    {
      label: 'City',
      name: 'city',
      checked: false,
    },
    {
      label: 'Lake',
      name: 'lake',
      checked: false,
    },
    {
      label: 'Ocean',
      name: 'ocean',
      checked: true,
    },
  ],
};

export const balcony = {
  isOpen: true,
  data: [
    {
      label: 'Only show rooms with balconies',
      name: 'with-balconies',
      checked: true,
    },
  ],
};

export const paymentOption = {
  isOpen: true,
  selectValue: {
    id: 'postpay',
    label: 'Postpay',
  },
  selectOptions: [
    {
      id: 'postpay',
      label: 'Postpay',
    },
    {
      id: 'prepay',
      label: 'Prepay',
    },
    {
      id: 'deposit',
      label: 'Deposit',
    },
    {
      id: 'pay-at-hotel',
      label: 'Pay at Hotel',
    },
  ],
};

export const wifi = {
  isOpen: true,
  data: [
    {
      label: 'Only show rooms with Good WIFI(TM)',
      name: 'with-wifi',
      checked: true,
    },
  ],
};

export const payAtHotel = {
  isOpen: true,
  data: [
    {
      label: 'Only show pay-at-hotel properties',
      name: 'pay-at-hotel',
      checked: false,
    },
  ],
};

export const beds = {
  isOpen: true,
  selectValue: {
    id: 1,
    label: 1,
  },
  selectOptions: [
    {
      id: 1,
      label: 1,
    },
    {
      id: 2,
      label: 2,
    },
    {
      id: 3,
      label: 3,
    },
  ],
};

export const amenities2 = {
  isOpen: true,
  data: [
    {
      label: 'Free WiFi',
      name: 'free-wifi',
      checked: false,
    },
    {
      label: 'Family Rooms',
      name: 'family-rooms',
      checked: false,
    },
    {
      label: 'Pet Friendly',
      name: 'pet-friendly',
      checked: false,
    },
    {
      label: 'Parking',
      name: 'parking',
      checked: true,
    },
    {
      label: 'Non Smoking Rooms',
      name: 'non-smoking-rooms',
      checked: true,
    },
    {
      label: 'Facilities For Disabled Guests',
      name: 'facilities-for-disabled-guests',
      checked: false,
    },
    {
      label: 'Room Service',
      name: 'room-service',
      checked: false,
    },
    {
      label: 'Airport Shuttles',
      name: 'airport-shuttles',
      checked: false,
    },
    {
      label: 'Restaurant',
      name: 'restaurant',
      checked: true,
    },
    {
      label: 'Swimming Pool',
      name: 'swimming-pool',
      checked: true,
    },
    {
      label: 'Fitness Center',
      name: 'fitness-center',
      checked: false,
    },
    {
      label: 'Spa',
      name: 'spa',
      checked: false,
    },
    {
      label: 'Balcony',
      name: 'balcony',
      checked: false,
    },
  ],
};
